/**
 * Count label for chips and cells: "1 class", "3 classes", "1 term", "2 terms".
 * Pass an explicit plural for irregular nouns; defaults to appending "s".
 */
export function pluralize(count: number, singular: string, plural?: string) {
  return `${count} ${count === 1 ? singular : plural ?? `${singular}s`}`
}
